import React from 'react';
import { withTranslation } from 'react-i18next';

class WhatWeDoDataProtection extends React.Component {
    render() {
        const { t } = this.props;
        const pillars = [
            t('pages.dataProtection.whatWeDo.item1'),
            t('pages.dataProtection.whatWeDo.item2'),
            t('pages.dataProtection.whatWeDo.item3'),
        ];
        return (
            <div className="dp-section dp-white mobile-page-padding">
                <div className="container">
                    <div className="dp-head-center">
                        <h2 className="dp-title">{t('pages.dataProtection.whatWeDo.title')}</h2>
                        <div className="dp-rule" />
                    </div>
                    <div className="dp-pillars">
                        {pillars.map((title, i) => (
                            <div className="dp-pillar" key={i}>
                                <div className="dp-pillar-num">{`0${i + 1}`}</div>
                                <h4>{title}</h4>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
};

export default withTranslation()(WhatWeDoDataProtection);
